<template>
  <Header></Header>
  <div><el-image :src="contact_dt"></el-image></div>
  <!-- 联系我们 -->
  <div class="fs30 c334 pt50 pb55">联系我们</div>
  <div class="lxwm">
    <div class="lxwm_text">
      <div class="dz white">
        <div class="fs20 pb30">樂滿門床具廠有限公司</div>
        <div class="line"></div>
        <p>公司地址：香港葵涌和宜合167-171號金威工業大廈5字樓A座</p>
        <p>在线客服：(852) 2427-1159</p>
        <p>公司傳真：(852) 2480-4601</p>
      </div>
    </div>
  </div>
  <Footer></Footer>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  name: "Contact",
  data() {
    return {
      contact_dt: "http://139.159.153.112:8200/gw_lmm/contact1.jpg",
    };
  },
  components: { Header, Footer },
};
</script>

<style scoped>
/* 联系我们 */
.lxwm {
  background-image: url(../assets/picture/addr.png);
  background-position: top center;
  background-repeat: no-repeat;
  width: 100%;
  height: 380px;
  /* background-size: auto 100%; */
}
.lxwm_text {
  width: 1100px;
  margin: 0 auto;
  text-align: left;
}
.dz {
  position: relative;
  top: 50px;
  left: 500px;
  width: 450px;
  padding: 30px 0px 30px 30px;
  background-color: #1b1919;
  opacity: 0.8;
}
.line {
  border-top: 1px solid #ffffff;
  width: 350px;
}
</style>